import { useLocation } from 'react-router';

// If you have a page or component that should not show these server notifications,
// add the logic here and then the final boolean check as an OR chain in hideNotifications
export const useHideNotifications = () => {
  const location = useLocation();

  const isCheckout = ['/cart/checkout', '/cart/guest_checkout'].some((url) =>
    location.pathname.includes(url)
  );

  const hideOnNewCheckoutPage = isCheckout;

  const hideNotifications = hideOnNewCheckoutPage;

  return hideNotifications;
};
